// extracted by mini-css-extract-plugin
module.exports = {"infoDescription":"_7afef76","infoValue":"_c4cfc51","standard":"_51c3a6f","inline":"_aa3c6b7","miniDetail":"_aeef468","noBottom":"_cae9304","persistentInfo":"_4d76f4f"};